import {
  AirPopulationItemResult,
  AirPopulationResultApi,
  AirPopulationStatus,
} from 'interfaces/types/AirPopulation'

export function checkValidDataApi(
  data: AirPopulationResultApi | null,
  exceptStateEmpty = false,
) {
  if (!data) return false
  return (
    typeof data?.state === 'string' &&
    (exceptStateEmpty ? true : data.state !== '') &&
    typeof data?.pollution?.aqius === 'number'
  )
}

export function checkValidData(
  data: AirPopulationItemResult | null,
  exceptStateEmpty = false,
) {
  if (!data) return false
  return (
    typeof data?.province === 'string' &&
    (exceptStateEmpty ? true : data.province !== '') &&
    typeof data?.currentAqiusValue === 'number'
  )
}

export function isValidStatus(value: string): value is AirPopulationStatus {
  return Object.values(AirPopulationStatus).includes(
    value as AirPopulationStatus,
  )
}
